import {Component, OnDestroy, OnInit} from '@angular/core';
import {LoaderService} from './loader.service';

@Component({
  selector: 'pbc-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss']
})
export class SpinnerComponent implements OnInit, OnDestroy {

  isLoading = false;

  constructor(public loaderService: LoaderService) { }

  ngOnInit() {
    this.loaderService.isLoading.subscribe((value: boolean)=> {
      this.isLoading = value;
    });
  }

  ngOnDestroy() {
    this.loaderService.isLoading.unsubscribe();
  }

}
